import { FIELD_STATUS } from '../../../reducers/status';
import { getForm } from '../../../selectors/publicWeb/naPersonalLoansCallMeBack';
import { transitionPersonalLoanForm } from '../../../actions/publicWeb/naPersonalLoansCallMeBack';

export const naPersonalLoansFormRules = (store, next, action) => {
    const result = next(action);
    const form = getForm(store.getState());
    const formValid = validateForm(form);

    const formAction = formValid ? transitionPersonalLoanForm.formValid() : transitionPersonalLoanForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateForm = (formFields) => {
    return (
        isValid(formFields, 'firstName') &&
        isValid(formFields, 'surname') &&
        isValid(formFields, 'idNumber') &&
        isValid(formFields, 'cellphoneNumber') &&
        isValid(formFields, 'town') &&
        isValid(formFields, 'employmentStatus') &&
        isValid(formFields, 'wageFrequency') &&
        isValid(formFields, 'payslip') &&
        isValid(formFields, 'employerName') &&
        isValid(formFields, 'creditCheckConsent')
    );
};

const isValid = (form, field) => form[field] && form[field].status === FIELD_STATUS.VALID;
